import { API_USER_URL } from "@/env";
import { message } from "antd";
import { BatchDetailAdminAPI, BatchPaymentAdminAPI, ProfitAdminAPI } from "./type";

const API_USE = API_USER_URL;
interface ProfitParams {
    page?: number;
    limit?: number;
    status?: string; // "all", "paid", "pending"
    period?: string; // "YYYY-MM"
    package_name?: string; // filter by package name
    batch?: boolean;
}
async function getListProfits(params: ProfitParams = {}): Promise<ProfitAdminAPI> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }

        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append("page", params.page.toString());
        if (params.limit) queryParams.append("perpage", params.limit.toString());
        if (params.status) queryParams.append("status", params.status);
        if (params.period) queryParams.append("period", params.period);
        if (params.package_name) queryParams.append("package_name", params.package_name);
        if (params.batch && params.batch !== undefined) queryParams.append("batch", "1");

        const response = await fetch(`${API_USE}/api/v1/be/admin/profit?${queryParams.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data as ProfitAdminAPI;

    } catch (error) {
        console.error("Error fetching profit list:", error);
        message.error("Failed to fetch profit list.");
        throw error;
    }
}
interface DetailProfitParams {
    id: number;
    period: string; // "YYYY-MM"
}
async function getDetailProfit(params: DetailProfitParams): Promise<any> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }
        const response = await fetch(`${API_USE}/api/v1/be/admin/profit/${params.id}?period=${params.period}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error fetching profit detail:", error);
        message.error("Failed to fetch profit detail.");
        throw error;
    }
}

async function createBatchPayment(name: string, ids: any[]): Promise<any> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }

        const response = await fetch(`${API_USE}/api/v1/be/admin/profit/create-batch`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                title: name,
                profit_ids: ids
            })
        });

        const data = await response.json();
        if (data.status === false) {
            message.error(data.message || "Failed to create batch payment.");
        }
        return data;
    } catch (error) {
        console.error("Error creating batch payment:", error);
        message.error("Failed to create batch payment.");
        throw error;
    }
}
interface BatchPaymentParams {
    period?: string; // "YYYY-MM"
    status?: string; // for
    search?: string;
    limit?: number;
    page?: number;
}
async function getListBatchPayment(params: BatchPaymentParams = {}): Promise<any> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }

        const queryParams = new URLSearchParams();
        if (params.period) queryParams.append("period", params.period);
        if (params.status) queryParams.append("status", params.status);
        if (params.search) queryParams.append("search", params.search);
        if (params.limit) queryParams.append("perpage", params.limit.toString());
        if (params.page) queryParams.append("page", params.page.toString());
        const response = await fetch(`${API_USE}/api/v1/be/admin/profit/batch?${queryParams.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error fetching batch payment list:", error);
        message.error("Failed to fetch batch payment list.");
        throw error;
    }
}

async function confirmProfitPayment(id: number): Promise<BatchPaymentAdminAPI> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }
        const response = await fetch(`${API_USE}/api/v1/be/admin/profit/approve/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data as BatchPaymentAdminAPI;

    } catch (error) {
        console.error("Error confirming profit payment:", error);
        message.error("Failed to confirm profit payment.");
        throw error;
    }
}

interface DetailBatchPaymentParams {
    id: number;
    search?: string;
    status?: string;
    package?: string;
    limit?: number;
    page?: number;
}

async function getDetailBatchPayment(params: DetailBatchPaymentParams): Promise<BatchDetailAdminAPI> {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authentication token found");
        }
        const paramsQuery = new URLSearchParams();
        if (params.search) paramsQuery.append("search", params.search);
        if (params.status) paramsQuery.append("status", params.status);
        if (params.package) paramsQuery.append("package_name", params.package);
        if (params.limit) paramsQuery.append("perpage", params.limit.toString());
        if (params.page) paramsQuery.append("page", params.page.toString());
        const response = await fetch(`${API_USE}/api/v1/be/admin/profit/batch/${params.id}?${paramsQuery.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data as BatchDetailAdminAPI;

    } catch (error) {
        console.error("Error fetching batch payment detail:", error);
        message.error("Failed to fetch batch payment detail.");
        throw error;
    }
}

export {
    getListProfits,
    getDetailProfit,
    confirmProfitPayment,
    createBatchPayment,
    getListBatchPayment,
    getDetailBatchPayment
};